module.exports = __webpack_public_path__ + "static/media/ux-fundomate-persona-shane@2x.1364bd6f.png";